








































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import {
    faDollarSign,
    faUser,
    faHomeAlt,
    faBars,
    faUserMd,
    faListAlt,
    faFileAlt,
    faCog,
    faSignOut,
    faSearch,
    faCloudUpload,
    faUnlockAlt,
} from '@fortawesome/pro-regular-svg-icons';
import { Resolve } from 'vue-di';
import { Title } from '~/decorators/Title';
import SessionModule from '~/store/session';
import styles from '~/assets/style/variables.scss';
import LoginModule from '~/store/login';
import EnrollmentModule from '~/store/enrollment';
import EligibilityModule from '~/store/eligibility';
import SearchModule from '~/store/search';

@Component<SideBar>({
    layout: 'default',
    icons: {
        faDollarSign,
        faUser,
        faHomeAlt,
        faBars,
        faUserMd,
        faListAlt,
        faFileAlt,
        faCog,
        faSignOut,
        faSearch,
        faCloudUpload,
        faUnlockAlt,
    },
})
export default class SideBar extends Vue {
    @Resolve
    public login!: LoginModule;
    @Resolve
    session!: SessionModule;
    @Resolve
    enrollment!: EnrollmentModule;
    @Resolve
    eligibility!: EligibilityModule;
    @Resolve
    search!: SearchModule;

    styles = styles;
    private _drawer = true;
    right = false;
    left = true;
    panel = [];
    panelIndex = {};
    minWindowSize = 1024;
    isAutosize = true;

    get isHub() {
        return this.session.isHub;
    }

    @Watch('panelIndex')
    watchPanelIndex() {
        if (this.session.isMiniVariant && this.panelIndex >= 0) {
            this.session.toggleMiniVariant();
        }
    }

    get miniVariant() {
        return this.session.isMiniVariant;
    }

    handleMiniClick() {
        this.isAutosize = false;
        if (window.outerWidth >= this.minWindowSize) {
            this.session.toggleMiniVariant();
        }

        if (this.session.isMiniVariant && this.panelIndex >= 0) {
            this.panelIndex = -1;
        }
    }

    handleResize() {
        if (window.outerWidth < this.minWindowSize && !this.session.isMiniVariant) {
            this.session.toggleMiniVariant();
        } else if (window.outerWidth >= this.minWindowSize && this.session.isMiniVariant && this.isAutosize) {
            this.session.toggleMiniVariant();
        }
    }

    get drawer() {
        return this.login.isAuthenticated ? this._drawer : false;
    }

    set drawer(value: boolean) {
        this._drawer = value;
    }

    get icons() {
        return this.$vuetify!.icons!.values!.radioOn;
    }

    get menuItems() {
        return [
            {
                icon: 'fal fa-home',
                text: 'Home',
            },
        ];
    }

    sendTo(page: string) {
        this.enrollment.clear();
        this.eligibility.clear();
        this.search.clearResults();
        // eslint-disable-next-line handle-callback-err
        this.$router.push({ path: page }).catch(error => {});
    }
    async handleLogOut() {
        await this.session.logout({ returnTo: this.$settings.absoluteUrlFromRoute({ name: 'index' }).replace(process.env.appUrl!, '') });
    }
    created() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    }
    destroyed() {
        window.removeEventListener('resize', this.handleResize);
    }
}
